import React, {Component} from 'react';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';
import ErrorPage from './ErrorPage';
import UserDetailsTFAF from "./UserDetailsTFAF";
import HeaderTFAF from "./HeaderTFAF";
import FooterTFAF from "./FooterTFAF";
import PolicyDetailsTFAF from "./PolicyDetailsTFAF";
import PolicyDetailsTFAFBackup from "./PolicyDetailsTFAFBackup";
import CarDetailsTFAF from "./CarDetailsTFAF";
import SessionExpirePopup from "./SessionExpirePopup";
import {getFeatureValue} from "../services/featureHubClient";
import CarDetailsTFAFBackup from "./CarDetailsTFAFBackup";
import MBILandingPage from "./MBILandingPage";
import {detectSource} from "../utils/sourceDetection";

class MultiStepFormTFAF extends Component {
    state = {
        source:'',
        vehicleData: {},
      step: 0,
        excess:0,
        sessionTimeout: 900,
        expirySessionTimeout: 120,
        showCookieExpiryPopup: false,
        expireSession: false,
      modification: "",
        taxiExclusion: null,
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        jointFirstName: '',
        jointLastName: '',
        jointDateOfBirth: '',
        joint: false,
        email: '',
        phone: '',
        mobile: '',
        full_address: '',
        addressLine1: '',
        addressLine2: '',
        suburb: '',
        city: '',
        postcode: '',
        benefits: null,
        quote: null,
        amendQuoteResponse: null,
        vehicleInputValue:'',
        vehicleInputOdometerValue:'',
        exclusions: '',
      isModified: '',
      existingIssue: '',
        aaMember: '',
        aaMembershipNumber: '',
        aaMemberLastName: '',
        aaMemberDOB: '',
        validAaMember: 'NO',
      propulsionOptions: [],
        applicantType:'',
        businessName:'',
        selectedTermAndCover:null,
        variant:null,
        id:'',
        registration:'',
        additionalBenefit: null,
        quoteExpiry:'',
        retrieveQuote:false,
      digimbiEnabled: false,
      featureFlagsEvaluated: false,
      aaRoadService: false,
      consumables: false,
      travelDisruption: false,
      saveQuoteButtonEnabled: false,
      featureFlagSaveQuoteButtonEvaluated: false,
      mbiRecaptchaEnabled: false,

    }

    updateBenefits = (updatedBenefits) => {
        this.setState({
            benefits: updatedBenefits
        })
    }

    updateQuote = (updatedQuote) => {
        this.setState({
            quote: updatedQuote
        })
    }
    updateAmendQuoteResponse = (updatedAmendQuoteResponse) => {
        this.setState({
            amendQuoteResponse: updatedAmendQuoteResponse
        })
    }

  componentDidMount() {
    // Check for step parameter in URL and set initial step accordingly
    const urlParams = new URLSearchParams(window.location.search);
    const stepParam = urlParams.get('step');
    if (stepParam === '1') {
      this.setState({step: 1});
    }
    // Feature flags will be evaluated when moving to step 2
  }

  componentDidUpdate = (prevProps,prevState) => {
        if (prevState.sessionTimeout !== this.state.sessionTimeout) {
            setTimeout(() => {
                this.handleChangeValue('showCookieExpiryPopup', false);
                if(this.state.expireSession) {
                    const baseUrl = window.location.origin;
                    const stepPages = {
                        1: { virtualUrl: `${baseUrl}/mbi/step1`, pageTitle: 'Car Details' },
                        2: { virtualUrl: `${baseUrl}/mbi/step2`, pageTitle: 'Choose Your Cover' },
                        3: { virtualUrl: `${baseUrl}/mbi/step3`, pageTitle: 'Policyholder' },
                    };
                    const currentPage = stepPages[this.state.step] || { virtualUrl: `${baseUrl}/mbi/`, pageTitle: '' };
                    if (!window.location.hostname.includes('aa')) {
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({
                          event: 'mbiAutosureEvent',
                          category: 'Session Expired',
                          virtualUrl: currentPage.virtualUrl,
                          pageTitle: currentPage.pageTitle,
                      });
                    }
                    window.location.href = '/mbi/session-expired';
                }
            }, this.state.sessionTimeout * 1000);
            setTimeout(() => {
                this.handleChangeValue('expireSession', true);
                // clearTimeout(timer);
                this.handleChangeValue('showCookieExpiryPopup', true);
            }, this.state.sessionTimeout * 1000 - (this.state.expirySessionTimeout * 1000));
        }

    // Re-evaluate feature flags if source changes
    if (prevState.source !== this.state.source) {
      this.evaluateFeatureFlags();
    }
  }

  evaluateFeatureFlags = () => {
    try {
      const detectedSource = this.detectSourceFromUrl();

      // Update state source if it changed
      if (detectedSource !== this.state.source) {
        this.setState({source: detectedSource});
      }

      const digimbiEnabled = getFeatureValue('digimbi', false, detectedSource);
      const mbiRecaptchaEnabled = getFeatureValue('mbirecaptcha', false, detectedSource);
      console.log('[DEBUG] FeatureHub evaluation - Source:', detectedSource, 'digimbi:', digimbiEnabled, 'mbirecaptcha:', mbiRecaptchaEnabled);
      this.setState({digimbiEnabled: digimbiEnabled, mbiRecaptchaEnabled: mbiRecaptchaEnabled, featureFlagsEvaluated: true});
    } catch (error) {
      console.warn('Error evaluating feature flags:', error);
      this.setState({digimbiEnabled: false, mbiRecaptchaEnabled: false, featureFlagsEvaluated: true});
    }
  }

    nextStep = () => {
        const {step} = this.state
        this.setState({
            step: step + 1
        })
    }

    prevStep = () => {
        const {step} = this.state
        this.setState({
            step: step - 1
        })
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value})
    }

    handleChangeValue = (name, value) => {
        this.setState({[name]: value})
    }

    detectSourceFromUrl = () => {
        // Use the centralized source detection utility
        return detectSource();
    }
  evaluateFeatureFlagSaveQuoteButton = () => {
    try {
      const detectedSource = this.detectSourceFromUrl();

      // Update state source if it changed
      if (detectedSource !== this.state.source) {
        this.setState({source: detectedSource});
      }

      const saveQuoteButtonEnabled = getFeatureValue('savequotebutton', false, detectedSource);
      console.log('[DEBUG] FeatureHub evaluation - saveQuoteButtonEnabled of Source:', detectedSource, 'Value:', saveQuoteButtonEnabled);
      this.setState({saveQuoteButtonEnabled: saveQuoteButtonEnabled, featureFlagSaveQuoteButtonEvaluated: true});
    } catch (error) {
      console.warn('Error evaluating saveQuoteButtonEnabled feature flags:', error);
      this.setState({saveQuoteButtonEnabled: false, featureFlagSaveQuoteButtonEvaluated: true});
    }
  }
  wrapWithRecaptcha = (content) => {
    if (!this.state.mbiRecaptchaEnabled) return content;
    const reCaptchaKey = (this.state.source === 'AA' || this.state.source === 'AA_MEMBER')
      ? '6LdjcdYtAAAAANZBINQ8kaI_jjxdjUhmKWlIXWxh'
      : '6LeyJ7IqAAAAAKoJo1rsg6cNch-Db3TDm3TKryo7';
    return (
      <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
        {content}
      </GoogleReCaptchaProvider>
    );
  }

    render() {
        const {
            source,
            vehicleData,
            step,
            excess,
            sessionTimeout,
            showCookieExpiryPopup,
            expireSession,
            benefits,
            quote,
            amendQuoteResponse,
            modification,
            firstName,
            lastName,
            dateOfBirth,
            joint,
            jointFirstName,
            jointLastName,
            jointDateOfBirth,
            email,
            phone,
            mobile,
            full_address,
            addressLine1,
            addressLine2,
            suburb,
            city,
            postcode,
            taxiExclusion,
            vehicleInputValue,
            vehicleInputOdometerValue,
            exclusions,
          isModified,
          existingIssue,
            aaMember,
            aaMembershipNumber,
            aaMemberLastName,
            aaMemberDOB,
            validAaMember,
          propulsionOptions,
            applicantType,
            businessName,
            selectedTermAndCover,
            variant,
            id,
            registration,
            additionalBenefit,
            quoteExpiry,
            retrieveQuote,
          digimbiEnabled,
          aaRoadService,
          consumables,
          travelDisruption,
          saveQuoteButtonEnabled,
          mbiRecaptchaEnabled,
        } = this.state;
        const inputValues = {
            source,
            vehicleData,
            sessionTimeout,
            excess,
            showCookieExpiryPopup,
            expireSession,
            benefits,
            quote,
            amendQuoteResponse,
            modification,
            firstName,
            lastName,
            dateOfBirth,
            joint,
            jointFirstName,
            jointLastName,
            jointDateOfBirth,
            email,
            phone,
            mobile,
            full_address,
            addressLine1,
            addressLine2,
            suburb,
            city,
            postcode,
            taxiExclusion,
            vehicleInputValue,
            vehicleInputOdometerValue,
            exclusions,
          isModified,
          existingIssue,
            aaMember,
            aaMembershipNumber,
            aaMemberLastName,
            aaMemberDOB,
            validAaMember,
          propulsionOptions,
            applicantType,
            businessName,
            selectedTermAndCover,
            variant,
            id,
            registration,
            additionalBenefit,
            quoteExpiry,
            retrieveQuote,
          digimbiEnabled,
          aaRoadService,
          consumables,
          travelDisruption,
          saveQuoteButtonEnabled,
          mbiRecaptchaEnabled,
        };
        switch (step) {
          case 0:
            if (!this.state.featureFlagsEvaluated) {
              this.evaluateFeatureFlags();
              return null; // wait for state update
            }
            if (this.state.digimbiEnabled) {
              const queryParams = new URLSearchParams(window.location.search);
              const id = queryParams.get("id");
              if (id) {
                this.nextStep();
                return null;
                // this.setState({step: 2});
              }
              if (this.state.source === 'MYAUTOSHOP' || this.state.source === 'MONEYHUB' || this.state.source === 'AA' || this.state.source === 'AA_MEMBER' || this.state.source === 'VTNZ' || this.state.source === 'QUASHED') {
                this.nextStep();
                return null;
              }
              return this.wrapWithRecaptcha(<>
                <HeaderTFAF/>
                <MBILandingPage onGetQuote={this.nextStep}/>
                <FooterTFAF/>
              </>);
            } else {
              console.log("start 0 else")
              // If not evaluated, immediately move to step 1
              this.nextStep(); // increment step
              return null; // don't render anything for this render cycle
            }
            case 1:
              // Evaluate feature flags when entering step 1 (only once)
              if (!this.state.featureFlagsEvaluated) {
                this.evaluateFeatureFlags();
              }
              const CarComponent = this.state.digimbiEnabled ? CarDetailsTFAF : CarDetailsTFAFBackup;
              if (!this.state.featureFlagSaveQuoteButtonEvaluated) {
                this.evaluateFeatureFlagSaveQuoteButton();
                return null; // wait for state update
              }
                return this.wrapWithRecaptcha(<>
                    <SessionExpirePopup
                        inputValues={inputValues}
                        handleChangeValue={this.handleChangeValue}/>
                    <HeaderTFAF/>

                  <CarComponent
                        nextStep={this.nextStep}
                        prevStep={this.prevStep}
                        handleChange={this.handleChange}
                        handleChangeValue={this.handleChangeValue}
                        inputValues={inputValues}
                        updateBenefits={this.updateBenefits}
                        updateQuote={this.updateQuote}
                        updateAmendQuoteResponse={this.updateAmendQuoteResponse}
                    />
                    <br/><br/>
                    <FooterTFAF/>
                </>)

            case 2:
              // Evaluate feature flags when entering step 2 (only once)
              if (!this.state.featureFlagsEvaluated) {
                this.evaluateFeatureFlags();
              }
              const PolicyComponent = this.state.digimbiEnabled ? PolicyDetailsTFAF : PolicyDetailsTFAFBackup;

              return this.wrapWithRecaptcha(<>
                    <SessionExpirePopup
                        inputValues={inputValues}
                        handleChangeValue={this.handleChangeValue}/>
                    <HeaderTFAF/>
                <PolicyComponent
                        nextStep={this.nextStep}
                        handleChange={this.handleChange}
                        handleChangeValue={this.handleChangeValue}
                        inputValues={inputValues}
                        prevStep={this.prevStep}
                        parentQuote={JSON.parse(this.state.quote)}
                        parentBenefit={JSON.parse(this.state.benefits)}
                        parentAmendQuoteResponse={JSON.parse(this.state.amendQuoteResponse)}
                        updateAmendQuoteResponse={this.updateAmendQuoteResponse}
                        cover1={this.state.digimbiEnabled ?
                          (this.state.source == 'TFAF_AUTOSURE' || this.state.source == 'MONEYHUB' || this.state.source == 'MYAUTOSHOP' || this.state.source == 'GASPY' || this.state.source == 'VTNZ' || this.state.source == 'AA' || this.state.source == 'QUASHED' ? 'Advantage' : 'Assist Plus') :
                          (this.state.source == 'TFAF_AUTOSURE' || this.state.source == 'MONEYHUB' || this.state.source == 'MYAUTOSHOP' || this.state.source == 'GASPY' || this.state.source == 'VTNZ' ? 'Extreme Plus' : 'Assist Plus')
                        }
                        cover2={this.state.digimbiEnabled ?
                          (this.state.source == 'TFAF_AUTOSURE' || this.state.source == 'MONEYHUB' || this.state.source == 'MYAUTOSHOP' || this.state.source == 'GASPY' || this.state.source == 'VTNZ' || this.state.source == 'AA' || this.state.source == 'QUASHED' ? 'Advantage Plus' : 'Assist') :
                          (this.state.source == 'TFAF_AUTOSURE' || this.state.source == 'MONEYHUB' || this.state.source == 'MYAUTOSHOP' || this.state.source == 'GASPY' || this.state.source == 'VTNZ' ? 'Smart Cover' : 'Assist')
                        }
                    />
                    <br/><br/><br/>
                  <div style={{
                    marginBottom: selectedTermAndCover?.coverName ? '60px' : 0,
                    backgroundColor: '#EBEBEB'
                  }}>
                    <FooterTFAF/>
                  </div>
                </>)
            case 3:
                return this.wrapWithRecaptcha(<>
                    <SessionExpirePopup
                        inputValues={inputValues}
                        handleChangeValue={this.handleChangeValue}/>
                    <HeaderTFAF/>
                    <UserDetailsTFAF
                        nextStep={this.nextStep}
                        handleChange={this.handleChange}
                        handleChangeValue={this.handleChangeValue}
                        inputValues={inputValues}
                        prevStep={this.prevStep}
                        parentQuote={JSON.parse(this.state.quote)}
                    />
                    <br/><br/>
                    <FooterTFAF/>
                </>)
            default:
                return this.wrapWithRecaptcha(<>
                    <SessionExpirePopup
                        inputValues={inputValues}
                        handleChangeValue={this.handleChangeValue}/>
                    <HeaderTFAF/>
                    <ErrorPage/><br/><br/>
                    <FooterTFAF/></>)
        }
    }
}

export default MultiStepFormTFAF;

